export default __webpack_public_path__ + "static/media/devloper.59d74783.svg";